module.exports = angular.module('cartographer.common.app.react', [])

$ = require 'jquery'
_ = require 'underscore'

module.exports.factory 'crtWebApp', $DI (crtLog, crtConfig) ->
  root = if crtConfig.local
    "http://localhost:3000"
  else if crtConfig.beta
    "https://app.beta.cartographer.io"
  else if crtConfig.next
    "https://app.next.cartographer.io"
  else
    "https://app.cartographer.io"

  workspaceRef = (workspace) ->
    if typeof workspace == "string"
      workspace
    else
      workspace.subdomain

  return {
    homeUrl: ->
      root
    workspaceHomeUrl: (workspace) ->
      "#{root}/ws/#{workspaceRef(workspace)}"
    workspaceSettingsUrl: (workspace) ->
      "#{root}/ws/#{workspaceRef(workspace)}/settings"
    workspaceListUrl: ->
      "#{root}/admin/workspaces"
    createWorkspaceUrl: ->
      "#{root}/admin/workspaces/new"
    adminUrl: ->
      "#{root}/admin"
    userTransferUrl: ->
      "#{root}/admin/transfer/user"
  }
